import { render } from "./Modalcart.vue?vue&type=template&id=66f3fc8d"
import script from "./Modalcart.vue?vue&type=script&lang=js"
export * from "./Modalcart.vue?vue&type=script&lang=js"

import "./Modalcart.vue?vue&type=style&index=0&id=66f3fc8d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__